import { render, staticRenderFns } from "./BienMap.vue?vue&type=template&id=2dd5491b"
import script from "./BienMap.vue?vue&type=script&lang=js"
export * from "./BienMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports